import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import DataHelper, { DataHelperConfiguration } from "@Scripts/Common/DataHelper";

@Component({ name: "SupportTicketMessageHistory" })
export default class SupportTicketMessageHistory extends Vue {
    public localizer: any = (<any>window).DataWeb.Localizer;
    public isLoading: boolean = false;
    public isTicket: boolean = false;
    public messages: any[] = [];
    public dataConfiguration: DataHelperConfiguration = { culture: (<any>window).App.userCulture };

    @Prop() control: any;
    @Prop() store: string;
    @Prop() context: any;
    @Prop() isDisabled: boolean;
    @Prop() isFormUpdating: boolean;

    get navigationContext() {
        return this.$store.getters["navigationStore/navigationContext"];
    }

    @Watch("isFormUpdating") onIsFormUpdatingChanged(value: boolean, oldValue: boolean) {
        if (value == true && !this.control.isLateDataBinding) {
            this.getData();
        }
    }

    public created() {
        this.$emit("created", this.control);

        this.getData();
    }

    public async getData() {
        this.isLoading = true;
        if (!this.control.isLateDataBinding || !this.isFormUpdating) {
            let data = { fullName: this.control.fullName, dataSourceParameters: this.control.dataSourceParameters }

            for (let propertyName in this.context) {
                data[propertyName] = this.context[propertyName];
            }

            let response = await Axios.post("/dataweb/api/control/controlsupportticketmessagehistory/getdata?nav=" + this.context.nav, data);

            this.isTicket = response.data.isTicket;
            this.messages = response.data.messages;

            this.isLoading = false;

            this.$emit("loaded", this.control);
        }
    }

    public convertToLocalDate(date: string): string {
        return DataHelper.convertDateToString(date, this.dataConfiguration, true, true);
    }
};